import { Injectable } from '@angular/core';

export const STORAGE_KEYS = {
  LOGIN_TOKEN: 'loginToken',
  GLOBAL_USER: 'globalUser',
  TENANT_ID: 'tenantId',
  MFA_TOKEN: 'mfaToken',
  AUTH_DATA: 'auth_data',
} as const;

@Injectable({ providedIn: 'root' })
export class StorageService {
  setItem<T>(key: string, value: T): void {
    try {
      localStorage.setItem(key, typeof value === 'string' ? value : JSON.stringify(value));
    } catch (e) {
      console.error(`StorageService: failed to set "${key}"`, e);
    }
  }

  getItem<T>(key: string): T | null {
    try {
      const raw = localStorage.getItem(key);
      if (raw === null) return null;
      try {
        return JSON.parse(raw) as T;
      } catch {
        return raw as unknown as T;
      }
    } catch (e) {
      console.error(`StorageService: failed to get "${key}"`, e);
      return null;
    }
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  clear(): void {
    Object.values(STORAGE_KEYS).forEach(k => localStorage.removeItem(k));
  }
}
